import {
  linkSearchItems,
  norm,
} from "components/v2/Listings/ListingsRouterUrlHelper";
import useTranslation from "next-translate/useTranslation";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { selectors as ListingsReducerSelectors } from "../../../../redux/slices/v2/ListingReducer";
import styles from "./index.module.css";

// import cfgBank from "./cfgbank.png";
import Image from "next/image";
import { province_to_slug } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import { useEffect, useState } from "react";
import { style } from "@mui/system";
import ExcluCard from "./ExcluCard";
import ListingsSubList from "components/v2/Listings/ListingsSubList";
import { selectors as ListingreducerSelectors } from "redux/slices/v2/ListingReducer";
export default function SideBarAnnonce({
  userData,
  totalListingsCount,
  displayMap,
  fixAlert,
  fixEnd,
}: {
  userData: any;
  totalListingsCount: number;
  displayMap: boolean;
  fixAlert?: boolean;
  fixEnd?: boolean;
}) {
  const { t, lang } = useTranslation("annonceAchat");
  const currentListing = useSelector(
    ListingreducerSelectors.currentListingSelactor
  );

  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );

  const handleLinksRedirect = (typeRedirect: string) => {
    // const queryParams = window.location.search.slice(1);
    // const newLink = `/fr/${typeRedirect}.htm?${queryParams}`;
    // window.location.href = newLink;
    const {
      region,
      controlBy,
      meublee,
      no_trigger_search,
      page,
      ...filteredPayload
    } = searchPayload;

    let copySP = {};
    if (searchPayload.exclusivite) {
      copySP["exclusivite"] = searchPayload.exclusivite;
    }
    if (searchPayload.virtual_tour) {
      copySP["virtual_tour"] = searchPayload.virtual_tour;
    }
    if (searchPayload.vendu) {
      copySP["vendu"] = searchPayload.vendu;
    }
    if (searchPayload.bounds) {
      copySP["bounds"] = [
        searchPayload.bounds._sw.lat,
        searchPayload.bounds._sw.lng,
        searchPayload.bounds._ne.lat,
        searchPayload.bounds._ne.lng,
      ];
    } else if (window) {
      if (window.cartedesannonces) {
        if (window.cartedesannonces.getBounds) {
          let boundsref = window.cartedesannonces.getBounds();
          copySP["lat"] = window.cartedesannonces.getCenter().lat;
          copySP["lng"] = window.cartedesannonces.getCenter().lng;
          copySP["zoom"] = window.cartedesannonces.getZoom();
          copySP["bounds"] = [
            boundsref._sw.lat,
            boundsref._sw.lng,
            boundsref._ne.lat,
            boundsref._ne.lng,
          ];
        }
      }
    }

    linkSearchItems.map((item) => {
      if (
        (searchPayload[item] && searchPayload[item].length) ||
        (typeof searchPayload[item] == "number" &&
          parseInt(searchPayload[item].toString()))
      ) {
        copySP[item] = searchPayload[item];
      }
    });
    if (filteredPayload["province"]) {
      copySP["province"] = province_to_slug[filteredPayload["province"]];
    }
    copySP["zoom"] = searchPayload.zoom ? searchPayload.zoom : 8;

    copySP["commune"] = searchPayload.commune
      ? norm(searchPayload.commune)
      : "";
    const u = new URLSearchParams(copySP).toString();

    let link = `/${lang}/${typeRedirect}.htm${u ? `?${u}` : ""}`;

    return link;
    // window.location.href = newLink;
  };

  const [exclusivity, setExclusivity] = useState(searchPayload.exclusivite);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const exclu = urlSearchParams.get("exclusivite");
    setExclusivity(exclu === "true" ? true : false);
  }, []);

  return (
    <div className={styles.parent}>
      {displayMap ? (
        <a
          className={styles.div}
          style={{
            position: "relative",
            cursor: "pointer",
          }}
          href={handleLinksRedirect("map")}
          rel="noindex,nofollow, noreferrer"
        >
          <Image
            style={{
              objectFit: "cover",
              objectPosition: "center",
              width: "100%",
              zIndex: "-1",
            }}
            priority={true}
            alt="Annonce appartement ou maison à vendre"
            src={
              searchPayload.transaction_type == "Location"
                ? "https://images.agenz.ma/uploads/mockup-map-location_1080x750.webp"
                : searchPayload.transaction_type == "Vente"
                  ? searchPayload.vendu ? "https://images.agenz.ma/uploads/Maps_1080x750.webp" : "https://images.agenz.ma/uploads/mockup-map-vente_1080x750.webp"
                  : "https://images.agenz.ma/uploads/mockup-map-neuf_1080x750.webp"
            }
            unoptimized
            fill
          />
          <span
            className={styles.rsultats}
            // onClick={()=>{
            //   handleLinksRedirect("map")
            // }}
            rel="nofollow, noindex"
          >
            <span className={styles.iconoutlinemap}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 16.6666L2.96066 14.3969C2.67834 14.2558 2.5 13.9672 2.5 13.6516V4.68161C2.5 4.06213 3.15193 3.65922 3.70601 3.93626L7.5 5.83325M7.5 16.6666L12.5 14.1666M7.5 16.6666V5.83325M12.5 14.1666L16.294 16.0636C16.8481 16.3406 17.5 15.9377 17.5 15.3182V6.34828C17.5 6.03264 17.3217 5.74408 17.0393 5.60292L12.5 3.33325M12.5 14.1666V3.33325M12.5 3.33325L7.5 5.83325"
                  stroke="#00111A"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <div className={styles.group}>
              <div className={styles.div1}>
                <NumberFormat
                  displayType={"text"}
                  value={totalListingsCount}
                  thousandSeparator={" "}
                />
              </div>
              <div className={styles.rsultats1}>
                {t("biens à voir sur la carte")}
              </div>
            </div>
          </span>
        </a>
      ) : null}
      {exclusivity ? (
        <div className={styles.deskGanger}>
          <ExcluCard t={t} lang={lang} />
        </div>
      ) : null}
      <div
        className={`${fixEnd ? styles.activeConEnd : styles.activeCon} ${fixAlert ? styles.activerLalerteFix : ""
          }`}
      >
        <div className={`${styles.activerLalerte}`}>
          <div className={styles.activerLalerteWrapper}>
            {/* this Besoin aide leav it as it is just do it just for  "?" to be translated */}
            <b className={styles.activerLalerte1}>{`${t(
              "Besoin d'aide ?"
            )} `}</b>
          </div>
          <div className={styles.pourCetteRecherchePourReceWrapper}>
            <div className={styles.activerLalerte1}>
              {t("Entrez en relation avec votre conseiller privilégié agenz")}
            </div>
          </div>
          <div
            className={styles.activerLalerte2}
            onClick={() => {
              window.open(
                `https://api.whatsapp.com/send?phone=${
                // userData
                //   ? userData.isPro
                //     ? "+212664211141"
                //     :
                // searchPayload.transaction_type == "Projets Neufs" ? "+212665250835" : "+212669793808"
                searchPayload.transaction_type == "Projets Neufs"
                  ? "+212665250835"
                  : "+212669793808"
                }&text=${t(
                  searchPayload.exclusivite
                    ? userData
                      ? userData.isPro
                        ? "Bonjour, J'aimerais avoir plus d'informations concernant les exclusivités Agenz et le partage de commission"
                        : "Bonjour, J'ai un projet immobilier et je souhaiterai être accompagné"
                      : "Bonjour, J'ai un projet immobilier et je souhaiterai être accompagné"
                    : "Bonjour, J'ai un projet immobilier et je souhaiterai être accompagné"
                )}%0a`
              );
            }}
          >
            {/* <img className={styles.socialIcon1} alt="" src="Social icon.svg" /> */}
            <div className={styles.socialIcon1}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="icons8-whatsapp 1">
                  <path
                    id="Vector"
                    d="M19.077 4.928C17.191 3.041 14.683 2.001 12.011 2C6.505 2 2.024 6.479 2.022 11.985C2.021 13.745 2.481 15.463 3.355 16.977L2 22L7.233 20.763C8.692 21.559 10.334 21.978 12.006 21.979H12.01C17.515 21.979 21.996 17.499 21.999 11.994C22.001 9.325 20.963 6.816 19.077 4.928ZM16.898 15.554C16.69 16.137 15.671 16.699 15.213 16.74C14.755 16.782 14.326 16.947 12.218 16.116C9.681 15.116 8.079 12.515 7.955 12.349C7.83 12.182 6.936 10.996 6.936 9.768C6.936 8.54 7.581 7.936 7.81 7.687C8.039 7.437 8.309 7.375 8.476 7.375C8.642 7.375 8.809 7.375 8.954 7.381C9.132 7.388 9.329 7.397 9.516 7.812C9.738 8.306 10.223 9.54 10.285 9.665C10.347 9.79 10.389 9.936 10.306 10.102C10.223 10.268 10.181 10.372 10.057 10.518C9.932 10.664 9.795 10.843 9.683 10.955C9.558 11.079 9.428 11.215 9.573 11.464C9.719 11.714 10.219 12.531 10.961 13.192C11.915 14.042 12.718 14.305 12.968 14.431C13.218 14.556 13.363 14.535 13.509 14.368C13.655 14.202 14.133 13.64 14.299 13.39C14.465 13.14 14.632 13.182 14.861 13.265C15.09 13.348 16.317 13.952 16.566 14.077C16.816 14.202 16.982 14.264 17.044 14.368C17.106 14.471 17.106 14.971 16.898 15.554Z"
                    fill="white"
                  />
                </g>
              </svg>
            </div>
            <div
              data-tracking="click"
              data-value="help-annonce-whatsapp"
              className={styles.activerLalerte3}
            >
              {t("Contacter")}
            </div>
          </div>
        </div>

        <ListingsSubList
          onlyPopularSearch={true}
          quartier={
            typeof searchPayload.quartier == "string"
              ? searchPayload.quartier
                ? searchPayload.quartier
                : ""
              : searchPayload.quartier
                ? searchPayload.quartier[0]
                  ? searchPayload.quartier[0]
                  : ""
                : ""
          }
          province={searchPayload.province ? searchPayload.province : ""}
          transaction_type={searchPayload.transaction_type}
          type={searchPayload.type[0]}
          currentListing={currentListing ? true : false}
        />
        {/* <img className={styles.unsplashUb9b5gxhbyIcon} alt="" src={cfgBank.src} /> */}
      </div>
    </div>
  );
}
